export default function () {
  return {
    boost: {}
  }
}
